import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/build/projects/Kredo/layouts/default.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/app/build/projects/Kredo/layouts/public.vue").then(m => m.default || m))
}